<template>
    <!-- <b-input-group class="question-plain" :class="expedienteItemId" :key="expedienteItemId">
        <b-form-label>{{ question }}</b-form-label>
        <b-form-textarea v-model="workingValue" @change="updateExpdient"></b-form-textarea>
    </b-input-group> -->
    <div class="question-plain" key="expedienteItemId">
        <b-row no-gutter no-gutters> 
            <b-col sm="12" class="text-left">
                <label :for="itemId">{{ question }}</label>
            </b-col>
            <b-col sm="12">
                <b-form-datepicker :readonly="readonly" v-if="tipo == 'fecha'" :id="itemId" size="sm" v-model="workingValue" />
                <b-input-group v-else-if="['numero', 'numero_positivo'].includes(tipo)" size="sm" :append="(item.unidades_numero) ? item.unidades_numero : null">
                    <b-form-input :id="itemId" :readonly="readonly" type="number" v-model="workingValue" :min="(tipo == 'numero_positivo') ? 0 : null"/>
                    <template v-if="!readonly">
                        <b-input-group-append>
                            <b-button @click="workingValue = parseInt(workingValue||0) - 1" :disabled="!(tipo == 'numero' || workingValue > 0)">-</b-button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <b-button @click="workingValue = parseInt(workingValue||0) + 1">+</b-button>
                        </b-input-group-append>
                    </template>
                </b-input-group>
                <b-form-select :disabled="readonly" v-else-if="['opcional', 'opcional_multiple'].includes(tipo)" v-model="workingValue" :options="item.opciones ? item.opciones.replace(/\r/g, '').split('\n') : []"> 
                    <template #first>
                        <b-form-select-option value="" disabled>-- Selecciona una opción --</b-form-select-option>
                    </template>
                </b-form-select>
                <b-form-textarea :readonly="readonly" v-else :id="itemId" size="sm" v-model="workingValue" />
            </b-col>
        </b-row>
        <div class="code" v-if="debug">
            <pre>{{ workingValue }}</pre>
            <pre>{{ item.opciones }}</pre>
            <pre>{{ item.opciones ? item.opciones.replace(/\r/g, '').split('\n') : [] }}</pre>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
export default {
    name: 'QuestionPlain',
    props: {
        debug: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => {
                return {
                    unidades_numero: '',
                    // id: null,
                    // nombre: null,
                    // tipo: null,
                    // respuesta: null,
                    // fecha: null,
                    // expedienteItemId: null
                }
            }
        },
        tipo: {
            type: String,
            default: 'abierta'
        },
        expedienteItemId: {
            type: [String, Number],
            // required: true
        },
        value: {
            type: [Array]
        },
        question: {
            type: String,
            required: true
        }
    },
    computed: {
        itemId() {
            return 'exp-id-' + this.expedienteItemId
        }
    },
    data: () => {
        return {
            // sizes: ['Small', 'Medium', 'Large', 'Extra Large'],
            workingValue: '',
        }
    },
    methods: {
        loadFromValue() {
            // Carga el valor del expediente en workingValue, si existe
            let expediente = _.clone(this.value)
            let index = _.findIndex(expediente, { expedienteItemId: this.expedienteItemId })
            if (index >= 0) {
                this.workingValue = _.clone(expediente[index][this.getExpedienteProperty()])
            } else {
                this.workingValue = null
            }
        },
        updateExpdient() {
            // Trabaja el expediente con clones, el caso es que si this.value tiene un objeto con el valor clave expedienteItemId indicado en las propiedades, actualiza su propiedad "respuesta" con el valor en workingValue, en caso de que no lo tenga, enpuja el objeto con la propiedad expedienteItemId y respuesta respectivamente

            let expediente = _.clone(this.value)
            let index = _.findIndex(expediente, { expedienteItemId: this.expedienteItemId })
            let workingValue = _.clone(this.workingValue)
            if (typeof workingValue == 'string')
                workingValue = workingValue.trim();
            if (index >= 0) {
                expediente[index][this.getExpedienteProperty()] = _.clone(workingValue);
            } else {
                let newItem = {
                    expedienteItemId: this.expedienteItemId,
                }
                newItem[this.getExpedienteProperty()] = _.clone(workingValue);
                expediente.push(newItem)
            }
            this.$emit('input', expediente)
        },
        getExpedienteProperty() {
            switch (this.tipo) {
                case 'fecha':
                    return 'fecha';
                case 'numero':
                case 'numero_positivo':
                    return 'numero';
                default:
                    return 'respuesta';
            }
        }
    },
    watch: {
        value(){
            this.loadFromValue()
        },
        workingValue() {
            this.updateExpdient()
        }
    },
    beforeMount(){
        this.loadFromValue();
    }
}
</script>

<style lang="scss">
.question-plain {
    label {
        font-weight: bold;
    }
}
</style>